function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState, useCallback } from "react";
import ConfirmModal from "../../forms/confirmmodal/ConfirmModal";
import { useId } from "../../helpers/hooks";
const useConfirmModal = () => {
  const id = useId();
  const eventName = `confirm-modal-${id}`;
  const [isOpen, setIsOpen] = useState(false);
  const showModal = useCallback(() => new Promise(resolve => {
    setIsOpen(true);
    window.addEventListener(eventName, function listener(event) {
      setIsOpen(false);
      resolve(event.detail);
      window.removeEventListener(eventName, listener);
    });
  }), [isOpen]);
  const Modal = useCallback(props => {
    return /*#__PURE__*/React.createElement(ConfirmModal, _extends({}, props, {
      isOpen: isOpen,
      onConfirm: () => {
        const event = new CustomEvent(eventName, {
          detail: true
        });
        window.dispatchEvent(event);
      },
      onCancel: () => {
        const event = new CustomEvent(eventName, {
          detail: false
        });
        window.dispatchEvent(event);
      }
    }));
  }, [isOpen]);
  Modal.displayName = "Modal";
  return [Modal, showModal];
};
export default useConfirmModal;
//# sourceMappingURL=useConfirmModal.js.map